<template>
  <div class="layout">
    <vHeader></vHeader>
    <div class="layout-content">
      <Row>
        <i-col :span="spanLeft" :class="[spanLeft < 2 ? 'layout-hide-text' : 'layout-show-text']" class="leftMenuContainer">
          <!-- 左侧菜单组件 -->
          <vLeft></vLeft>
        </i-col>
        <!--router-view 路由组件 -->
        <i-col :spanRight="spanRight" :span="spanRight" :offset="spanLeft" :class="{'layout-right': spanRight > 21}">
          <div class="layout-breadcrumb">
            <!-- 面包屑 -->
            <keep-alive>
              <Breadcrumb>
                <template v-for="item in menuMap">
                  <Breadcrumb-item v-if="item.link" replace :href="item.link.split('#/')[1]" :key="item.id">{{item.mainTitle}}</Breadcrumb-item>
                  <Breadcrumb-item v-else :key="item.id">{{item.mainTitle}}</Breadcrumb-item>
                </template>
              </Breadcrumb>
            </keep-alive>
          </div>
          <keep-alive>
            <router-view></router-view>
          </keep-alive>
        </i-col>
      </Row>
    </div>
  </div>
</template>
<script>
import menuLogisticProvider from '@/api/menuLogisticProvider';
import menuOwLogisticProvider from '@/api/menuOwLogisticProvider';
import menuSeller from '@/api/menuSeller';
import menuAdmin from '@/api/menuAdmin';
import indexAdmin from '@/api/indexAdmin';
import vHeader from './header';
import vLeft from './left';
import layoutMixin from '@/components/mixin/layout_mixin';
import Mixin from '@/components/mixin/common_mixin';
export default {
  mixins: [ Mixin, layoutMixin ],
  components: {
    vHeader,
    vLeft
  },
  data () {
    return {
      menu: ''
    };
  },
  computed: { // 动态计算属性,
    spanLeft () {
      let v = this;
      let fullScreen = v.$store.state.fullScreen;
      if (v.domWidth > 2100 && !fullScreen) {
        v.$store.commit('spanLeft', 2);
      } else if (v.domWidth > 1800 && !fullScreen) {
        v.$store.commit('spanLeft', 3);
      } else if (v.domWidth > 1250 && !fullScreen) {
        v.$store.commit('spanLeft', 4);
      } else if (v.domWidth <= 1250 && !fullScreen) {
        v.$store.commit('spanLeft', 5);
      } else if (fullScreen) {
        v.$store.commit('spanLeft', 0);
      }
      return v.$store.state.spanLeft !== 0 ? v.$store.state.spanLeft : 0;
    },
    spanRight () {
      return 24 - this.$store.state.spanLeft;
    },
    topMenuName () {
      return this.$store.state.breadMenu.firstMenu;
    },
    subMenuOpt () {
      return this.$store.state.breadMenu.subMenu;
    },
    inPageId () { // 当前页面的ID
      return this.getInPageId(this.$store.state.thisPage);
    },
    menuMap () {
      return this.processCrumbData();// 加载左侧菜单
    }
  },
  methods: {
    getInPageId (thisPage) { // 获取当前页面的ID
      let v = this;
      let t;
      let inGroup = v.$store.state.inGroup;
      v.menu[inGroup].forEach((n, i) => {
        if (!n.pid && n.pid !== 0) {
          v.$store.commit('inGroupId', n.id);
        }
        if (n.link !== undefined && v.getLastPageName(n.link) === thisPage && thisPage !== '') {
          t = n.id;
        }
      });
      return t;
    },
    // 处理面包屑逻辑
    processCrumbData () {
      let _data = [];
      let v = this;
      let inGroup = this.$store.state.inGroup;
      let _func = function (targetId) {
        v.menu[inGroup].forEach(val => {
          if (val.id === targetId) {
            _data.splice(0, 0, val);
            if (val.pid) {
              _func(val.pid);
            }
          }
        });
      };
      _func(this.inPageId);
      return _data;
    }
  },
  created () {
    let v = this;
    let inGroup = this.$store.state.inGroup; // 读取所在业务
    switch (inGroup) {
      case 'logisticsProvider' :
        v.menu = menuLogisticProvider;
        break;
      case 'seller':
        v.menu = menuSeller;
        break;
      case 'adminService':
        v.menu = menuAdmin;
        break;
      case 'index':
        v.menu = indexAdmin;
        break;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/layout/main.vue